import Vue from 'vue'
import Vuex from 'vuex'
import jwt_decode from 'jwt-decode'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    status: '',
    garrafas: [],
    token: localStorage.getItem('tokenDrink') || '',
    refreshing: false,
    user : localStorage.getItem("userDrink") ? JSON.parse(localStorage.getItem("userDrink")) : { idUsuario: 0 }
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, newData){
      state.status = 'success'
      state.token = newData.token
      state.user = JSON.parse(newData.userObj)
    },
    auth_error(state){
      state.status = 'error'
    },
    start_refresh(state){
      state.refreshing = true
    },
    auth_refresh(state, newToken) { 
      state.refreshing = false
      state.token = newToken.access_token
      state.rtoken = newToken.refresh_token
    },
    logout(state){
      state.status = ''
      state.rtoken = ""
      state.token = ''
      state.user = { idUsuario: 0 }
    },
    getting_info(state, user){
      state.user=user
    },
    set_garrafas(state, garrafas) { 
      state.garrafas = garrafas
    }
  },
  actions: {
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        fetch(Vue.prototype.$drink_uri + "/login", {
            method: "OPTIONS",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(user),
          })
        .then((response) => response.json())
        .then((resp) => {
            if (resp.token !== undefined) { 
              const token =  resp.token
              const userObj = JSON.stringify(jwt_decode(token, {algorithm: "RS256"}))

              localStorage.setItem('userDrink', userObj)
              localStorage.setItem('tokenDrink', token )

              commit('auth_success', { token, userObj})
              resolve(resp)
            }
            else { 
              window.console.log('login invalido')
              commit('auth_error')

              reject(resp)
            }       
        })
        .catch(err => {
          commit('auth_error')
          window.console.log(err)
          localStorage.removeItem('tokenDrink')
          localStorage.removeItem('userDrink')
          reject(err)
        })
      })
    },
    logout({commit}){
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('tokenDrink')
        localStorage.removeItem('userDrink')

        // delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})



export default store